import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = {
  key: 0,
  class: "notice bg-light-primary rounded border-primary border border-dashed mb-3 mt-3 p-6"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "fs-2 text-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-center mb-2" }, [
  /*#__PURE__*/_createVNode("b", null, "CONGRATULATIONS!")
], -1)
const _hoisted_10 = { class: "text-center mb-2" }
const _hoisted_11 = { class: "text-center mb-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "text-center mb-2" }, " Welcome to the next level—keep striving for excellence! ", -1)
const _hoisted_13 = { class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "fs-2 text-gray-600" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_20 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("PMA Reminder for ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_23 = /*#__PURE__*/_createVNode("a", {
  class: "btn btn-sm btn-danger me-3",
  href: "#/estore"
}, "complete your maintenance NOW", -1)
const _hoisted_24 = {
  key: 0,
  class: "dashboardFontStyle mb-2"
}
const _hoisted_25 = { class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "fs-2 text-gray-600" }
const _hoisted_30 = { class: "dashboardFontStyle mb-2" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_32 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_33 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_34 = {
  key: 1,
  class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6"
}
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "fw-bold" }
const _hoisted_37 = { class: "fs-2 text-gray-600" }
const _hoisted_38 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_40 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("New PMA Redemption Schedule")
const _hoisted_42 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode("           In our ongoing efforts to enhance system performance and ensure a smooth and efficient experience for all users, we are implementing a new policy regarding the encoding of PMA points. This policy aims to distribute system load more evenly throughout the month, thereby reducing traffic congestion during peak periods. ")
const _hoisted_44 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_45 = /*#__PURE__*/_createTextVNode("           1) Gold Executives and Global Ambassadors must encode their PMA from the 1st to the 15th of each month. ")
const _hoisted_46 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode("                     Example: June 1 to 15, 2024 ")
const _hoisted_48 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_49 = /*#__PURE__*/_createTextVNode("           2) Silver Executives and New Distributors must encode their PMA from the 1st to the 29th of each month. ")
const _hoisted_50 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode("                     Example: June 1 to 29, 2024 ")
const _hoisted_52 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode("           *** No PMA encoding during the 30th and 31st of the month. *** ")
const _hoisted_54 = {
  key: 2,
  class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6"
}
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "fw-bold" }
const _hoisted_58 = { class: "fs-2 text-gray-600" }
const _hoisted_59 = { class: "dashboardFontStyle mb-2" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_61 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Cheque encashment for Uganda is temporarily unavailable. ")
const _hoisted_63 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_64 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_65 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Starting Oct 10, 2024, we shall have cashless transactions in all our branches. We shall only accept bank payments. You may deposit your payments at: ")
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-md-6 mt-3 mb-3" }
const _hoisted_69 = {
  class: "dashboardFontStyle mb-2 text-center",
  align: "justify"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("b", null, "STANBIC", -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode()
const _hoisted_72 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 9030010927810")
const _hoisted_74 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" ALLIANCE IN MOTION GLOBAL (UGANDA) L ")
const _hoisted_76 = { class: "col-md-6 mb-3" }
const _hoisted_77 = {
  class: "dashboardFontStyle mb-2 text-center",
  align: "justify"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("b", null, "ECOBANK", -1)
const _hoisted_79 = /*#__PURE__*/_createTextVNode()
const _hoisted_80 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" 7170002437")
const _hoisted_82 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" ALLIANCE IN MOTION GLOBAL UGANDA LT ")
const _hoisted_84 = {
  key: 3,
  class: "row"
}
const _hoisted_85 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_86 = /*#__PURE__*/_createVNode("img", {
  src: "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_MOBILE.jpg",
  height: "370"
}, null, -1)
const _hoisted_87 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("img", { src: "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_PC.jpg" }, null, -1)
const _hoisted_89 = {
  key: 4,
  class: "row"
}
const _hoisted_90 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_91 = /*#__PURE__*/_createVNode("img", {
  src: "https://images.empoweredconsumerism-static-files.com/ecp/BDO_MC_Advisory_MOBILE.jpg",
  height: "370"
}, null, -1)
const _hoisted_92 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_93 = /*#__PURE__*/_createVNode("img", { src: "https://images.empoweredconsumerism-static-files.com/ecp/BDO_MC_Advisory_PC.jpg" }, null, -1)
const _hoisted_94 = { class: "notice bg-light-success rounded border-success border border-dashed mb-3 mt-3 p-6" }
const _hoisted_95 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = { class: "fw-bold" }
const _hoisted_99 = { class: "fs-2 text-gray-600" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_101 = { class: "svg-icon svg-icon-3tx svg-icon-success me-4" }
const _hoisted_102 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createTextVNode("OOTD MNL Hoodies will now be available! "),
  /*#__PURE__*/_createVNode("a", {
    class: "",
    href: "#/hoodiejacket"
  }, [
    /*#__PURE__*/_createVNode("u", null, "Click here")
  ]),
  /*#__PURE__*/_createTextVNode(" to select your preferred design. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_font = _resolveComponent("font")

  return (_ctx.pt != 'bibo' && _ctx.pt != 'ecc'  && _ctx.pt != 'pcp' && _ctx.ecShopAdvisoryVisibility.showComponent)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_ctx.ccode == 0 && _ctx.awarding_details.rank !== undefined)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4,
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode("p", _hoisted_10, " You have officially achieved the rank of " + _toDisplayString(_ctx.awarding_details.rank) + "! ", 1),
                        _createVNode("p", _hoisted_11, " Your barcode number is : " + _toDisplayString(_ctx.awarding_details.barcodenum), 1),
                        _hoisted_12
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("p", null, [
                      _hoisted_19,
                      _createVNode("span", _hoisted_20, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                      ]),
                      _createVNode(_component_font, { class: "fs-2" }, {
                        default: _withCtx(() => [
                          _createVNode("b", null, [
                            _hoisted_21,
                            _createVNode("u", null, _toDisplayString(_ctx.usid), 1),
                            _hoisted_22
                          ])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.unilevelMaintenancePromptMessage1) + " ", 1),
                      _hoisted_23,
                      _createTextVNode(" " + _toDisplayString(_ctx.unilevelMaintenancePromptMessage2), 1)
                    ]),
                    (_ctx.ecp_welcome_data.unilevelMaintenancePromptMessage2 != '')
                      ? (_openBlock(), _createBlock("p", _hoisted_24, "           " + _toDisplayString(_ctx.ecp_welcome_data.unilevelMaintenancePromptMessage2), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isShowPMAWarning]
          ]),
          _withDirectives(_createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("p", _hoisted_30, [
                      _hoisted_31,
                      _createVNode("span", _hoisted_32, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                      ]),
                      _createVNode(_component_font, { size: "5" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.csrMessage), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _hoisted_33
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isEnabledECCSRNotification]
          ]),
          false
            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, [
                      _createVNode("p", _hoisted_38, [
                        _hoisted_39,
                        _createVNode("span", _hoisted_40, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                        ]),
                        _createVNode("b", null, [
                          _createVNode(_component_font, { class: "fs-1" }, {
                            default: _withCtx(() => [
                              _hoisted_41
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createVNode("p", _hoisted_42, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("p", _hoisted_44, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        }),
                        _hoisted_46,
                        _hoisted_47
                      ]),
                      _createVNode("p", _hoisted_48, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        }),
                        _hoisted_50,
                        _hoisted_51
                      ]),
                      _createVNode("p", _hoisted_52, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_53
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createBlock("div", _hoisted_54, [
                _createVNode("div", _hoisted_55, [
                  _createVNode("div", _hoisted_56, [
                    _createVNode("div", _hoisted_57, [
                      _createVNode("div", _hoisted_58, [
                        _createVNode("p", _hoisted_59, [
                          _hoisted_60,
                          _createVNode("span", _hoisted_61, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _createVNode(_component_font, { size: "5" }, {
                            default: _withCtx(() => [
                              _hoisted_62
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("p", _hoisted_63, [
                          _hoisted_64,
                          _createVNode("span", _hoisted_65, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _createVNode(_component_font, { size: "4" }, {
                            default: _withCtx(() => [
                              _hoisted_66
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("div", _hoisted_67, [
                          _createVNode("div", _hoisted_68, [
                            _createVNode("p", _hoisted_69, [
                              _createVNode(_component_font, { size: "3" }, {
                                default: _withCtx(() => [
                                  _hoisted_70,
                                  _hoisted_71,
                                  _hoisted_72,
                                  _hoisted_73,
                                  _hoisted_74,
                                  _hoisted_75
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createVNode("div", _hoisted_76, [
                            _createVNode("p", _hoisted_77, [
                              _createVNode(_component_font, { size: "3" }, {
                                default: _withCtx(() => [
                                  _hoisted_78,
                                  _hoisted_79,
                                  _hoisted_80,
                                  _hoisted_81,
                                  _hoisted_82,
                                  _hoisted_83
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createBlock("div", _hoisted_84, [
                (_ctx.windowWidth <= 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_85, [
                      _hoisted_86
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth > 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_87, [
                      _hoisted_88
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isShowBDOMastercardAdvisory === true)
            ? (_openBlock(), _createBlock("div", _hoisted_89, [
                (_ctx.windowWidth <= 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_90, [
                      _hoisted_91
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth > 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_92, [
                      _hoisted_93
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("div", _hoisted_94, [
            _hoisted_95,
            _createVNode("div", _hoisted_96, [
              _createVNode("div", _hoisted_97, [
                _createVNode("div", _hoisted_98, [
                  _createVNode("div", _hoisted_99, [
                    _createVNode("p", null, [
                      _hoisted_100,
                      _createVNode("span", _hoisted_101, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                      ]),
                      _createVNode(_component_font, { class: "fs-2" }, {
                        default: _withCtx(() => [
                          _hoisted_102
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isShowHoodiePage == true]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}